import { Preferences } from '@capacitor/preferences';

export const saveStorage = async (key: string, value: string): Promise<void> => {
  await Preferences.set({ key, value });
};

export const getStorage = async (key: string): Promise<string | null> => {
  const { value } = await Preferences.get({ key });
  return value;
};

export const removeStorage = async (key: string): Promise<void> => {
  await Preferences.remove({ key });
};
